import React, { useState, useRef } from "react";
import { Callout, DirectionalHint } from "@fluentui/react";

import { TiFlowSwitch } from "react-icons/ti";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { invRecoCalloutStyles } from "../../styles_glob";
import styles from "./InvoiceItemsTable.module.css";
import { vertOrdOrd, vertMidl } from "../../inv_lsts";
import { MdOutlineAttachFile } from "react-icons/md";

const allItemsPropNotVal = (obj: any) => {
    return Object.keys(obj).filter(key => obj[key] === undefined || obj[key] === null);
};


// tooltip quantity
const tooltipReco = (objFunc: any, value: any, q_dif: number, u_dif: number, item?: any) => {
    return (
        <div className={styles.toolTipCompountQuantity}>
            <h3 className={styles.tooltipRecoTitle}>Reconciliation (beta)</h3>

            <div className={styles.toolTipCQSubTitle}>
                The following item was reconciliated from external data.
            </div>

            <div className={q_dif == 0 && u_dif == 0 ? styles.toolTipCQLeftHorizontalLine : styles.toolTipCQLeftHorRedLine}>
                <div className={styles.tooltipRecoGrid}>
                    <div className={styles.orderMatchSectionHead}>Order Match</div>

                    {Object.keys(objFunc)
                        .sort((a, b) => {
                            return vertOrdOrd.indexOf(a) - vertOrdOrd.indexOf(b);
                        })
                        .filter(f => vertOrdOrd.includes(f) && f !== "ai_recon")
                        .map((key) => (
                            <div key={key} className={styles.tooltipRecoItem}>
                                <div className={styles.tooltipRecoKey}>
                                    {key.replace(/_/g, " ")}
                                </div>
                                <div className={styles.tooltipRecoValue}>
                                    {objFunc[key]?.toString()}
                                </div>
                            </div>
                        ))
                    }

                    {Object.keys(item || {})
                        .sort((a, b) => {
                            return vertMidl.indexOf(a) - vertMidl.indexOf(b);
                        })
                        .filter(f => vertMidl.includes(f) && f !== "ai_recon")
                        .map((key) => (
                            <div key={key} className={styles.tooltipRecoItem}>
                                <div className={styles.tooltipRecoKey}>
                                    {key.replace(/_/g, " ")}
                                </div>
                                <div className={styles.tooltipRecoValue}>
                                    {item[key]?.toString()}
                                </div>
                            </div>
                        ))
                    }

                    {Object.keys(value)
                        .sort((a, b) => {
                            return vertOrdOrd.indexOf(a) - vertOrdOrd.indexOf(b);
                        })
                        .filter(f => vertOrdOrd.includes(f) && f !== "ai_recon")
                        .map((key) => (
                            <div key={key} className={styles.tooltipRecoItem}>
                                <div className={styles.tooltipRecoKey}>
                                    {key.replace(/_/g, " ")}
                                </div>
                                <div className={styles.tooltipRecoValue}>
                                    {value[key]?.toString()}
                                </div>
                            </div>
                        ))}
                </div>
                {Array.isArray(value?.multi_assign_pos) && value.multi_assign_pos.length > 0 && (
                    <div className={styles.tooltipRecoGrid}>
                        <div className={styles.orderMatchSectionHead}>Primary + {value.multi_assign_pos.length} more PO line(s) — totals above are combined</div>
                        {[value, ...value.multi_assign_pos].map((po: any, i: number) => (
                            <div key={po?.id ?? i} className={styles.tooltipRecoItem}>
                                <div className={styles.tooltipRecoKey}>
                                    {(po?.ai_recon?.purchase_order_id ?? po?.purchase_order ?? "")?.toString().split(";")[0]} · {po?.item_number ?? po?.id}
                                </div>
                                <div className={styles.tooltipRecoValue}>
                                    {po?.item_description ?? ""} ({po?.item_quantity ?? ""} × {po?.item_unit_price ?? ""})
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const getRecoIcon = (q_dif: number, u_dif: number, reco_type: string) => {
    return (q_dif == 0 && u_dif == 0) || reco_type == "reconcile" ? (
        <MdOutlineAttachFile size={15} />
    ) : q_dif != -9876543 || u_dif != -9876543 ? (
        <HiOutlineExclamationCircle size={15} />
    ) : (null);
};

interface recoCellStayOnHovProps {
    recon: any;
    value: any;
    q_dif: number;
    u_dif: number;
    reco_type: string;
    item?: any;
}

const recoCellStayOnHov: React.FC<recoCellStayOnHovProps> = ({ recon, value, q_dif, u_dif, reco_type, item }) => {
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const targetRef = useRef<HTMLSpanElement | null>(null);

    const onShow = () => setIsTooltipVisible(true);
    const onHide = () => setIsTooltipVisible(false);

    return (
        <div className={styles.recoField}>
            <span
                ref={targetRef}
                onMouseEnter={onShow}
                onMouseLeave={() => {
                    // delay so it doesn't vanish when moving into callout
                    setTimeout(() => {
                        if (!document.querySelector(`.${styles.toolTipCompountQuantity}:hover`)) {
                            onHide();
                        }
                    }, 100);
                }}
                className={styles.recoTrigger}
            >
                {getRecoIcon(q_dif, u_dif, reco_type)}
            </span>

            {isTooltipVisible && (
                <Callout
                    target={targetRef.current}
                    directionalHint={DirectionalHint.leftCenter}
                    gapSpace={8}
                    isBeakVisible={true}
                    className={styles.tooltipRecoContainer + " " + styles.tooltipRecoAnimated}
                    onMouseEnter={onShow}
                    onMouseLeave={onHide}
                    setInitialFocus
                    styles={invRecoCalloutStyles}
                >
                    {tooltipReco(recon, value, q_dif, u_dif, item)}
                </Callout>
            )}
        </div>
    );
};

export default recoCellStayOnHov;
